import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import m from "./iconfont.es5471.js";
const d = {
  display: "block"
}, v = ({ size: a = 16, useVw: n, useRem: t, color: o, withColor: i, removeClassName: l, disableSSR: p, style: c, ...x }) => {
  const h = c ? { ...d, ...c } : d;
  return /* @__PURE__ */ e.createElement(m, { disableSSR: p }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-fulizhongxin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: h, fill: "none", ...x }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: l ? "" : "32px-ç¦å©ä¸­å¿"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: l ? "" : "normal",
        d: "M12.016 3.36a.9.9 0 0 0-1.266 1.28l2.802 2.773H6a2.9 2.9 0 0 0-2.9 2.9v1.539a2.9 2.9 0 0 0 2.77 2.897v10.18a3.67 3.67 0 0 0 3.669 3.67h4.615a2.746 2.746 0 0 0 2.746-2.747V19.2a.9.9 0 0 0-1.8 0v6.652a.946.946 0 0 1-.946.946H9.54a1.87 1.87 0 0 1-1.87-1.87V14.753h16.662V24.93a1.87 1.87 0 0 1-1.87 1.87h-2.307a.9.9 0 0 0 0 1.8h2.308a3.67 3.67 0 0 0 3.67-3.67V14.75a2.9 2.9 0 0 0 2.768-2.897v-1.539a2.9 2.9 0 0 0-2.9-2.9h-7.555l2.802-2.773a.9.9 0 0 0-1.267-1.28l-3.965 3.926-.008.006a.025.025 0 0 1-.009.001l-.009-.001s-.004-.002-.007-.006L12.016 3.36ZM27.1 11.852a1.1 1.1 0 0 1-1.095 1.1H5.995a1.1 1.1 0 0 1-1.095-1.1v-1.539a1.1 1.1 0 0 1 1.1-1.1h20a1.1 1.1 0 0 1 1.1 1.1v1.539Z",
        fillRule: "evenodd",
        fill: i ? r(o, 0, "#262933") : "#262933",
        datafollowfill: i ? r(o, 0, "#262933") : "#262933"
      }
    )
  )));
}, u = v;
export {
  u as default
};
